<ng-content *ngIf="!showPlaceholder"></ng-content>
<ng-template [ngIf]="showPlaceholder">{{ content }}</ng-template>
